import React, { FunctionComponent } from 'react';
import Timestamp from '@justgiving/timestamp';
import { useTranslation } from 'react-i18next';

export type TimestampWrapperProps = {
  date: string;
};

const TimestampWrapper: FunctionComponent<TimestampWrapperProps> = ({
  date,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const utcTime = new Date(date).getTime();

  return (
    <Timestamp
      utcTime={utcTime}
      strings={{
        minute: t('times.minute', 'minute'),
        minutes: t('times.minutes', 'minutes'),
        hour: t('times.hour', 'hour'),
        hours: t('times.hours', 'hours'),
        day: t('times.day', 'day'),
        days: t('times.days', 'days'),
        month: t('times.month', 'month'),
        months: t('times.months', 'months'),
        year: t('times.year', 'year'),
        years: t('times.years', 'years'),
        seconds: t('times.seconds', 'seconds'),
        ago: t('times.ago', 'ago'),
      }}
    >
      {({
        // @ts-ignore // TODO Fix this in toolkit
        formattedTime,
      }) => formattedTime}
    </Timestamp>
  );
};

export default TimestampWrapper;
